module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "div_autre",
    attrs: {
      "epub:type": "preamble"
    }
  }, [_c('div', {
    staticClass: "pre",
    attrs: {
      "id": "pre-003"
    }
  }, [_c('h1', {
    staticClass: "pre_tit",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('span', [_vm._v("Foreword")])]), _c('div', {
    staticClass: "exergues"
  }, [_c('div', {
    staticClass: "exer"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea last"
  }, [_c('i', [_vm._v("The secret of a good sermon is to have a good beginning and a good ending, then having the two as close together as possible.")])]), _c('p', {
    staticClass: "auteur"
  }, [_vm._v("— George Burns")])])]), _c('div', {
    staticClass: "dev"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('span', {
    staticClass: "let"
  }, [_c('b', [_vm._v("H")])]), _vm._v("ave you somehow been charmed by the ads of my publisher or beguiled by the word-of-mouth ravings of a colleague about the inestimable merit of this book? Then you probably don’t need an introduction to this subject. It’s not likely you would have opened the cover if you didn’t already have at least an uneasy feeling about your knowledge deficiency—and maybe a genuine need to know about petroleum refining. In either event, you have come to the right place.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("The layout of the material in this book is designed to satisfy three needs. It can be used as a reference book because there’s a good table of contents in the front, a good index in the back, and a glossary of terms. The book has been used extensively as a text for courses on refinery processes. A combination of lectures, reading, and problem solving should be very reinforcing. Because most people do not have the luxury of listening to a lecturer like me, the layout is designed primarily for personal study. With that in mind, the dry material has been moistened with as much levity and practicality as I could render.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("For personal study the following plan might work. Chapters 1 and 2 are pleasant "), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-1"
    }
  }), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-2"
    }
  }), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-3"
    }
  }), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-4"
    }
  }), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-5"
    }
  }), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-6"
    }
  }), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-7"
    }
  }), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-8"
    }
  }), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-9"
    }
  }), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-10"
    }
  }), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-11"
    }
  }), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-12"
    }
  }), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-13"
    }
  }), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-14"
    }
  }), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-15"
    }
  }), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-16"
    }
  }), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-17"
    }
  }), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-18"
    }
  }), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-19"
    }
  }), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-20"
    }
  }), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-21"
    }
  }), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-22"
    }
  }), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-23"
    }
  }), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-24"
    }
  }), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-25"
    }
  }), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-26"
    }
  }), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-27"
    }
  }), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-28"
    }
  }), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-29"
    }
  }), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-30"
    }
  }), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-31"
    }
  }), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-32"
    }
  }), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-33"
    }
  }), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-34"
    }
  }), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-35"
    }
  }), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-36"
    }
  }), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-37"
    }
  }), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-38"
    }
  }), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-39"
    }
  }), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-40"
    }
  }), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-41"
    }
  }), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-42"
    }
  }), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-43"
    }
  }, [_vm._v("precursors, but Chapter 3 on ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-44"
    }
  }, [_vm._v("crude oil is a most important part of the book. For what goes on inside a refinery, Chapter 4 has a lot of mechanical detail that’s not fundamentally important. Don’t let it dismay you. The materials on ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-45"
    }
  }, [_vm._v("vacuum flashing, cat ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-46"
    }
  }, [_vm._v("cracking, ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-47"
    }
  }, [_vm._v("alkylation, reforming ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-48"
    }
  }, [_vm._v("hydrocracking, and ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-49"
    }
  }, [_vm._v("residue reduction are all important as lead-ins to ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-50"
    }
  }, [_vm._v("gasoline and other product blending. Struggle through Chapter 6 on chemistry.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-50"
    }
  }, [_vm._v("The chapter on ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-51"
    }
  }, [_vm._v("gasoline blending is the most fun (in a cerebral sort of way) because it deals with things familiar yet mysterious—car engines and ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-52"
    }
  }, [_vm._v("octane numbers. For anyone in the business part of the business, the chapter on simple and ")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-53"
    }
  }, [_vm._v("complex refineries will wrap up all the processes into a nice economic package.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-53"
    }
  }, [_vm._v("The other chapters are like "), _c('i', [_vm._v("lagniappe")]), _vm._v(", a nearly forgotten tradition where a Cajun merchant gives a small gift of appreciation at the time of sale. The information in those chapters, which reflect just as much labor on my part as the rest of the book, is useful but nevertheless not vital to understanding petroleum refining. So expand your attention span to work through at least the first fifteen chapters.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-53"
    }
  }, [_vm._v("Many thanks go to the people who have contributed to this and the four earlier editions of "), _c('i', [_vm._v("Petroleum Refining in Nontechnical Language.")]), _vm._v(" Of course, none of these could overcome my final say and massaging and, therefore, I carry the ultimate responsibility for getting everything right. And as always, I benefited from my wife allowing me long hours of solitude while I ground away at research and prose.")])]), _c('p', {
    staticClass: "txt_courant_droite"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-53"
    }
  }, [_vm._v("WLL, Winter 2020")])])])])]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-53"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30ed1363","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pre4.vue
// module id = 72
// module chunks = 0